import React, { useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import MultiLineChartCard from 'components/DetailWidgets/MultiLineChartCard'
import TabTable from '../TabTable'

const STATUS_TONE = {
  Active: 'bg-success bg-opacity-10 text-success',
  'At Risk': 'bg-orange-500 bg-opacity-10 text-orange-500',
  Pending: 'bg-body-text bg-opacity-10 text-body-text'
}

const COLUMNS = [
  { key: 'user', label: 'User' },
  { key: 'level', label: 'Current Level' },
  { key: 'currentStreak', label: 'Current Streak (Per Day)' },
  { key: 'coinsBonus', label: 'Coins Bonus (Per Day)' },
  { key: 'pointsBonus', label: 'Points Bonus (Multiplier)' },
  {
    key: 'progress',
    label: 'Progress to Next Level',
    render: (row) => (
      <div className="flex items-center gap-2 w-32">
        <div className="h-1.5 flex-1 rounded-full bg-background overflow-hidden">
          <div className="h-full bg-primary rounded-full" style={{ width: `${row.progress}%` }} />
        </div>
        <span className="text-xs text-secondary whitespace-nowrap">4/10 days</span>
      </div>
    )
  },
  {
    key: 'status',
    label: 'Status',
    render: (row) => <span className={`px-2 py-0.5 rounded text-xs font-medium ${STATUS_TONE[row.status] || STATUS_TONE.Pending}`}>{row.status}</span>
  },
  { key: 'lastActivity', label: 'Last Activity' }
]

const STATUS_OPTIONS = [
  { label: 'All statuses', value: '' },
  { label: 'Active', value: 'Active' },
  { label: 'At Risk', value: 'At Risk' },
  { label: 'Pending', value: 'Pending' }
]

export default function StreakTab({ campaign }) {
  const { streak } = campaign
  const [chartTab, setChartTab] = useState(streak.performance.tabs[0].key)

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {
          streak.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilSync} label={stat.label} value={stat.value} suffix={stat.suffix} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {
          streak.statsRow2.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilSync} label={stat.label} value={stat.value} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <div className="w-full rounded-2xl border border-border-lines p-4">
        <p className="text-base font-semibold text-dark-blue mb-4">Streak Performance</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {
            streak.performanceStats.map((stat) => (
              <StatCard key={stat.key} icon={UIcons.UilSync} label={stat.label} value={stat.value} tone={stat.tone} />
            ))
          }
        </div>
      </div>

      <MultiLineChartCard
        title="Streak Performance"
        series={streak.performance.seriesByTab[chartTab]}
        tabs={streak.performance.tabs}
        activeTab={chartTab}
        onTabChange={setChartTab}
      />

      <TabTable
        columns={COLUMNS}
        rows={streak.rows}
        searchPlaceholder="Search by name"
        searchKeys={['user']}
        statusOptions={STATUS_OPTIONS}
      />
    </div>
  )
}
